export enum AssetState {
    NO_ASSET,
    UPLOADING,
    PROCESSING,
    DOWNLOADING,
    DISPLAYING
}
